import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpErrorResponse, HttpEventType } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  //public REST_API_SERVER = "http://localhost/metanoa-api/frontend/web/?r="; //Dev
  //public REST_API_SERVER = "https://webapi.metanoa.ai/?r="; //Prod
  public REST_API_SERVER = "https://ae-api.metanoa.ai/?r="; //Prod-UAE
  public NIPMR_API = "https://api.metanoa.ai/?r="; //NIPMR API
  //public NIPMR_API = "http://nipmr-api.test/?r="; //NIPMR API

  constructor(private httpClient: HttpClient) { }

  public getOnlineAvailability(date,acId) {
    return this.httpClient.get(this.REST_API_SERVER + "widget/availability&date="+date+"&ac_id="+acId);
  }

  public postNewAppointment(data){
    return this.httpClient.post(this.REST_API_SERVER + "widget/add_appointment", data, {
      //headers: { 'key': localStorage.getItem("key") }
    });
  }

  public getOnlineAvailabilityNipmr(date,acId) {
    return this.httpClient.get(this.NIPMR_API + "widget/availability&date="+date+"&ac_id="+acId);
  }

  public postNewAppointmentNipmr(data){
    return this.httpClient.post(this.NIPMR_API + "widget/add_appointment", data, {
      //headers: { 'key': localStorage.getItem("key") }
    });
  }
}
